import { Button, Modal } from 'react-bootstrap';
import { useEffect,useState, useRef } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const EditPayout = ({ show, onClose, payoutData, onSuccess}) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const datePickerRef = useRef();

    // State for dropdown options - you may want to fetch them as you do in AddPayout or pass as props
    const [shiftOptions, setShiftOptions] = useState([]);
    const [staffOptions, setStaffOptions] = useState([]);
    const [paymentModeOptions, setPaymentModeOptions] = useState([]);

    // Form state
    const [selectedShiftTime, setSelectedShiftTime] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const [serviceSTTM, setServiceSTTMValue] = useState(new DateObject());
    const [deductions, setDeductions] = useState('');
    const [amount, setAmount] = useState(0);
    const [netPay, setNetPay] = useState(0);
    const [mobileNumber, setMobileNumber] = useState('');
    const [designation, setDesignation] = useState('');
    const [transactionId, setTransactionId] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

  // Fetch dropdown options once
    useEffect(() => {
        axios.get(`${baseURL}/shifttime`).then(res => {
            if (res.data && Array.isArray(res.data.data)) {
                setShiftOptions(res.data.data.filter(item => item.status === 0).map(item => ({ value: item.sno, label: item.shifttime_name })));
            } else {
                setShiftOptions([]);
                console.warn("Shift time data missing or invalid:", res.data);
            }
        });
        axios.get(`${baseURL}/managestaff`, { params : { branch_id: branch_id } }).then(res => {
            if (res.data && Array.isArray(res.data.data)) {
                setStaffOptions(res.data.data.map(item => ({
                    value: item.sno,
                    label: item.employee_name,
                    phone: item.phone_no,
                    designation: item.job_role?.jobrole_name || '',
                    salary: item.salary || 0
                })));
            } else {
                setStaffOptions([]);
                console.warn("Staff data missing or invalid:", res.data);
            }
        });

        // axios.get(`${baseURL}/paymentmode`).then(res => {
        //     if (res.data && Array.isArray(res.data)) {
        //         setPaymentModeOptions(res.data.map(item => ({ value: item.sno, label: item.paymentmode_name })));
        //     } else {
        //         setPaymentModeOptions([]);
        //         console.warn("Payment mode data missing or invalid:", res.data);
        //     }
        // });

        axios.get(`${baseURL}/paymentmode/getactive`)
            .then(response => {
                setPaymentModeOptions(
                    (response.data || []).map(item => ({ value: item.sno, label: item.paymentmode_name, transaction_id: item.transaction_id, }))
                );
            })
            .catch(err => console.error('Error fetching payment modes', err));

    }, [baseURL]);

    // Initialize form fields when payoutData changes
    // useEffect(() => {
    //     if (!payoutData) return;

    //     // Set Date/Time picker
    //     setServiceSTTMValue(new DateObject(payoutData.payout_date_time));

    //     // Set Shift Time selection
    //     setSelectedShiftTime({
    //     value: payoutData.shift_id,
    //     label: shiftOptions.find(o => o.value === payoutData.shift_id)?.label || '',
    //     });

    //     // Set Staff selection & details
    //     const staff = staffOptions.find(s => s.value === payoutData.staff_id);
    //     setSelectedStaff(staff || null);
    //     setMobileNumber(staff?.phone || '');
    //     setDesignation(staff?.designation || '');
    //     setAmount(staff?.salary || 0);

    //     // Deductions and net pay
    //     setDeductions(payoutData.deductions?.toString() || '');
    //     setNetPay(payoutData.net_pay || (staff?.salary || 0) - (payoutData.deductions || 0));

    //     // Payment mode
    //     setSelectedPaymentMode({
    //     value: payoutData.payout_method,
    //     label: paymentModeOptions.find(p => p.value === payoutData.payout_method)?.label || '',
    //     });

    //     setTransactionId(payoutData.transaction_id || '');
    //     setDescription(payoutData.description || '');
    // }, [payoutData, shiftOptions, staffOptions, paymentModeOptions]);

    useEffect(() => {
        if (!payoutData) return;
        if (shiftOptions.length === 0 || staffOptions.length === 0 || paymentModeOptions.length === 0) return;

        // Set date/time picker value
        setServiceSTTMValue(new DateObject(payoutData.payout_date_time));

        // Correctly set shift time select, value should be payoutData.shift_time
        // setSelectedShiftTime({
        //     value: payoutData.shift_time,   // <-- fix here
        //     label: shiftOptions.find(o => o.value === payoutData.shift_time)?.label || '',
        // });
        const shift = shiftOptions.find(o => o.value === payoutData.shift?.sno);
        console.log('payoutData:', payoutData);
        setSelectedShiftTime(shift || null);
        // Set staff select & details
        const staff = staffOptions.find(s => s.value === payoutData.staff_name);
        setSelectedStaff(staff || null);
        setMobileNumber(staff?.phone || '');
        setDesignation(staff?.designation || '');
        setAmount(staff?.salary || 0);

        // Deductions and net pay
        setDeductions(payoutData.deductions?.toString() || '');
        setNetPay(payoutData.net_pay || (staff?.salary || 0) - (payoutData.deductions || 0));

        // Payment mode select - match by number (ensure payoutData.payout_method is number)
        setSelectedPaymentMode({
            value: payoutData.payout_method?.sno,
            label: paymentModeOptions.find(p => p.value === payoutData.payout_method?.sno)?.label || 'Unknown Payment Mode',
        });

        setTransactionId(payoutData.transaction_id || '');
        setDescription(payoutData.description || '');
    }, [payoutData, shiftOptions, staffOptions, paymentModeOptions]);

    useEffect(() => {
        setNetPay(parseFloat((amount - (parseFloat(deductions) || 0)).toFixed(2)));
    }, [deductions, amount]);

    useEffect(() => {
        if (!selectedStaff) {
        setMobileNumber('');
        setDesignation('');
        setAmount(0);
        setNetPay(0);
        return;
        }
        setMobileNumber(selectedStaff.phone);
        setDesignation(selectedStaff.designation);
        setAmount(selectedStaff.salary);
        setNetPay(parseFloat((selectedStaff.salary - (parseFloat(deductions) || 0)).toFixed(2)));
        // setNetPay(selectedStaff.salary - (parseFloat(deductions) || 0));
    }, [selectedStaff, deductions]);


    const handleClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!selectedShiftTime) newErrors.shiftTime = "Shift Time is required";
        if (!selectedStaff) newErrors.staff = "Staff is required";
        if (!selectedPaymentMode) newErrors.paymentMode = "Payment mode is required";
        if (deductions.trim() === '') newErrors.deductions = "Deductions are required";
        // if (description.trim() === '') newErrors.description = "Description is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Submit update
    const handleSubmit = async () => {
        // console.log("handleSubmit called");
        if (!validate()){
            // console.log("Validation failed:", errors);
            return;
        } 

        const payload = {
            payout_date_time: serviceSTTM.format('YYYY-MM-DD HH:mm:ss'),
            shift_id: selectedShiftTime.value,
            staff_id: selectedStaff.value,
            payout_method: selectedPaymentMode.value,
            deductions: parseFloat(deductions),
            net_pay: netPay,
            amount: amount,
            description: description,
            transaction_id: selectedPaymentMode.value !== 2 ? transactionId : null,
            status: 1, // or get status from somewhere if editable
        };

        try {
            await axios.put(`${baseURL}/managepayouts/${payoutData.sno}`, payload);
            // setToastMessage('Payout updated successfully!');
            // setToastVariant('success');
            setShowToast(true);
            if (onSuccess) onSuccess();
            if (onClose) onClose();
            toast.success('Payout Updated Successfully');
        } catch (err) {
            // setToastMessage('Failed to update payout. Please try again.');
            // setToastVariant('danger');
            setShowToast(true);
            toast.error("Updation Failed")
            // console.error('Update payout error:', err.response?.data || err.message);
        
        }
    };

    // console.log(selectedOption, "gjkhjkh")


    return (
        <>
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Payout</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Date / Time<span className="required">*</span></label>
                            <div className="datepicker-wrapper d-flex" onClick={handleClick}>
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                </div>
                                <DatePicker
                                    ref={datePickerRef}
                                    value={serviceSTTM}
                                    onChange={setServiceSTTMValue}
                                    format="MM-DD-YYYY, hh:mm A"
                                    plugins={[
                                        <TimePicker position="bottom" />
                                    ]}
                                    disableDayPicker={false}
                                    className="custom-datepicker"
                                />
                            </div>

                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Shift Time<span className="required">*</span></label>
                            <Select placeholder='Select Shift Time'
                                value={selectedShiftTime}
                                onChange={setSelectedShiftTime}
                                options={shiftOptions}
                            />
                            {errors.shiftTime && <div className="text-danger fs-8 mt-1">{errors.shiftTime}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                value={selectedStaff}
                                onChange={setSelectedStaff}
                                options={staffOptions}
                            />
                            {errors.staff && <div className="text-danger fs-8 mt-1">{errors.staff}</div>}
                        </div>
                         <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Mobile Number</label>
                            <input type="text" className="form-control" placeholder="Enter Mobile Number" readOnly value={mobileNumber} />
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Designation<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Designation" value={designation} readOnly />
                        </div>

                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Amount</label>
                            <input type="text" className="form-control" placeholder="Enter Amount" value={amount} readOnly />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Deductions<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Deductions" value={deductions}
                                onChange={e => setDeductions(e.target.value)} />
                                {errors.deductions && <div className="text-danger fs-8 mt-1">{errors.deductions}</div>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Net Pay</label>
                            <input type="text" className="form-control" placeholder="Enter Net Pay" readOnly value={netPay} />
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Payout Method
                            </label>
                            <Select
                                placeholder="Select Payout Mode"
                                value={selectedPaymentMode}
                                onChange={setSelectedPaymentMode}
                                options={paymentModeOptions}
                            />
                            {errors.paymentMode && <div className="text-danger fs-8 mt-1">{errors.paymentMode}</div>}
                        </div>



                        {selectedPaymentMode && selectedPaymentMode.value !== 2 && (
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Transaction ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={transactionId}
                                    onChange={e => setTransactionId(e.target.value)}
                                    placeholder="Enter Transaction ID"
                                />
                            </div>
                        )}
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" placeholder="Description" value={description}
                                onChange={e => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Payout
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
        {/* <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        bg={toastVariant} // "success", "danger", etc.
        style={{ position: "fixed", top: 20, right: 20, minWidth: 250, zIndex: 1050 }}
      >
        <Toast.Body className="text-white">{toastMessage}</Toast.Body>
      </Toast> */}
    </>
    )
}

export default EditPayout;